import { call, put, all, takeEvery } from "redux-saga/effects";

import { searchActions } from '../slice/searchSlice'
import {
    searchApi,
} from 'services/searchServices'

function* handleSearch(action) {
    try {
        const res = yield call(searchApi, action.payload.query, action.payload.province, action.payload.min, action.payload.max, action.payload.sort, action.payload.page, action.payload.perPage, action.payload.person)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(searchActions.searchSuccess({ data: response.data, totalPage: response.totalPage, totalItem: response.totalItem }))
            }
            else {
                yield put(searchActions.searchFailed())
            }
        }
        else {
            yield put(searchActions.searchFailed())
        }
    } catch (error) {
        yield put(searchActions.searchFailed())
    }
}


export default function* searchSaga() {
    yield all(
        [
            takeEvery(searchActions.search.type, handleSearch),
        ]
    )
}
